import { render, staticRenderFns } from "./ConteudoInterativo.vue?vue&type=template&id=d895acde&"
import script from "./ConteudoInterativo.vue?vue&type=script&lang=js&"
export * from "./ConteudoInterativo.vue?vue&type=script&lang=js&"
import style0 from "./ConteudoInterativo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports